@if (offer) {
  <div
    class="offer-image-wrapper"
    [class.mode-tiles]="viewMode === 'tiles'"
    [class.mode-list]="viewMode === 'list'"
    [class.no-image]="!hasImage()"
    (click)="openModal()">
    @if (hasImage()) {
      <img
        class="offer-image"
        [ngSrc]="getDisplayImageUrl()"
        fill
        alt="Room image"
        (pointerdown)="onPointerDown($event)"
        (pointerup)="onPointerUp($event)"
        (pointercancel)="onPointerCancel()"
        (pointerleave)="onPointerCancel()"
        [priority]="index === 0" />
    } @else {
      <div class="offer-image-placeholder">No image</div>
    }

    <!-- Image counter (current / total) - click to cycle images -->
    @if (totalImages > 1) {
      <div
        class="img-counter"
        aria-hidden="true"
        (click)="nextImage($event)">
        <span class="img-counter-text">{{ currentImageIndex + 1 }} / {{ totalImages }}</span>
      </div>
    }

    <!-- Carousel controls -->
    @if (totalImages > 1) {
      <button
        type="button"
        class="carousel-btn prev"
        [lxResponsiveClass]="arrowResponsiveClass"
        aria-hidden="true"
        (click)="prevImage($event)">
        <span class="material-icons">chevron_left</span>
      </button>
    }

    @if (totalImages > 1) {
      <button
        type="button"
        class="carousel-btn next"
        [lxResponsiveClass]="arrowResponsiveClass"
        aria-hidden="true"
        (click)="nextImage($event)">
        <span class="material-icons">chevron_right</span>
      </button>
    }

    <!-- Carousel dots (indicator) -->
    @if (totalImages > 1) {
      <div class="carousel-dots">
        @for (_ of (offer.amenities.room_photo_urls || []); track _; let i = $index) {
          <div
            class="carousel-dot"
            [class.active]="i === currentImageIndex"
            (click)="goToImage(i, $event)"
          [attr.data-index]="i"></div>
        }
      </div>
    }

    <div
      [hidden]="offer.display_order !== 1"
      class="ribbon-red"
      [class.ribbon-red-list]="viewMode === 'list'"
      [class.ribbon-red-tiles]="viewMode === 'tiles'"
      [lxResponsiveClass]="{ horizontal: 'ribbon-red-desktop', vertical: 'ribbon-red-handset' }">
      <div class="txt-red">Popular</div>
    </div>

    <!-- <div class="ribbon-red" [hidden]="index !== 0">
    <span>Popular</span>
  </div> -->
</div>
}
